export enum NavigationDragDropActions {
    Reorder = 1,
    Add = 2,
    Remove = 3,
}
